import { render, staticRenderFns } from "./evolve.vue?vue&type=template&id=64fde1e6&"
import script from "./evolve.vue?vue&type=script&lang=js&"
export * from "./evolve.vue?vue&type=script&lang=js&"
import style0 from "./evolve.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports